import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { VChip } from "vuetify/lib";
import { EnumApprovalState } from "@/models/enum/Enum";

type Avatar = { icon: string; color: string };

type Props = {
  value: EnumApprovalState;
  level?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalChip',
  props: {
    value: null,
    level: null
  },
  setup(__props: any) {

const props = __props as {
  value: EnumApprovalState;
  level?: number;
};

const avatarList: Avatar[] = [
  { icon: "mdi-numeric-0", color: "grey darken-4" },
  { icon: "mdi-numeric-1", color: "blue darken-4" },
  { icon: "mdi-numeric-2", color: "orange darken-4" },
  { icon: "mdi-numeric-3", color: "green darken-4" }
];



const chip = computed(() => {
  switch (props.value) {
    case EnumApprovalState.UNAPPROVAL:
      return { text: "未承認", color: "" };
    case EnumApprovalState.RESOLVE:
      return { text: "承認", color: "success" };
    case EnumApprovalState.REJECT:
      return { text: "却下", color: "error" };
    case EnumApprovalState.DURING:
      return { text: "承認中", color: "primary" };
    case EnumApprovalState.WAITING:
      return { text: "承認待ち", color: "warning" };
    default:
      return undefined;
  }
});

const avatar = computed(() =>
  props.level != null ? avatarList[props.level] : undefined
);
const isSmall = computed(() => props.level == null);

return { __sfc: true,avatarList, props, chip, avatar, isSmall, VChip }
}

})